<template>
  <div class="pc-region">
    <!-- 院校头部面包屑部分 -->
    <div class="pc-region-bread">
      <h2>地图列表</h2>
      <BreadCrumb :data="breadcrumb" class="pc-new-breadcrumb" />
    </div>
    <!-- city头部内容部分 -->

    <StatisticalPanel :whichModule="'map'" :title="'竞赛数据'"
    :data="overallData"
    >
    </StatisticalPanel>

    <!-- bp标签管理 -->
    <div class="pc-region-tab">
      <Tag :typeTagArgs="typeTagArgs" @refresh="refresh"/>
    </div>
    <!-- bp表格 -->
    <div class="pc-region-table">
      <RegionTable ref="uniTable"/>
    </div>

  </div>
</template>
<script>
// 功能模板
import StatisticalPanel from '../../componentSet/Statistical/StatisticalPanel'
import {getCityGroups,getCities} from './regionList/regionList.gql'
// 页面模板
import BreadCrumb from "../../template/BreadCrumb";
import RegionTable from "./regionList/regionTable";
import Tag from "../../template/Tag";
export default {
  components: {
    BreadCrumb,
    StatisticalPanel,
    RegionTable ,
    Tag,
  },
  computed: {
    breadcrumb: function () {
      return [
        { name: "地图管理", link: "/admin/regionList" },
        { name: "地图列表", link: "/admin/regionList" },
      ];
    },
  },
  data() {
    return {
      overallData: {
        title: "城市数据",
        count: [{ name: "城市数量", count: null },{ name: "区域数量", count: null }],
      },
      // 标签接口
      regionTotal:null,
      cityTotal:null,
      typeTagArgs: {
        skip: 0,
        type: "REGION",
        title: "城市群",
        order: "+createTime",
      },
    };
  },
  created() {
    this.getRegions()
    this.getCities()
    

  },
  mounted() {
  },
  methods: {
    getRegions() {
      this.$global.GraphqlQuery(this, getCityGroups).then(res => {
        this.overallData.count[1].count= res.total
      })
    },
    getCities() {
      this.$global.GraphqlQuery(this, getCities, {take:1}).then(res => {
        this.overallData.count[0].count= res.total
      })
    },
    // 刷新搜索框
    refresh(){
      this.$refs.uniTable.neeedReSearch()
    },
  },

};
</script>
<style lang="scss" scoped>
.pc-region {
  .slot-first {
    h1, h2 {
      margin-top: 20px;
      font-family: $chinese;
      font-size: 55px;
      font-weight: normal;
      color: $timeBtn;
      text-align: center;
    }
    p {
      margin-top: 15px;
      font-family: $chinese;
      font-size: 14px;
      font-weight: 400;
      color: $mainTitle;
      text-align: center;
    }
    h2 {
      margin-top: 30px;
      color: $lightenYellow;
    }
  }
  // bp头部面包屑部分
   .slot-first {
    h1, h2 {
      margin-top: 20px;
      font-family: $chinese;
      font-size: 55px;
      font-weight: normal;
      color: $timeBtn;
      text-align: center;
    }
    p {
      margin-top: 15px;
      font-family: $chinese;
      font-size: 14px;
      font-weight: 400;
      color: $mainTitle;
      text-align: center;
    }
    h2 {
      margin-top: 30px;
      color: $lightenYellow;
    }
  }

  .pc-region-bread {
    display: flex;
    padding-bottom: 20px;
    border-bottom: 1px solid $border-color;
    > h2 {
      font-size: 20px;
      padding: 35px 40px 0 0;
      align-self: flex-end;
    }
  }
  // bp内容部分
  .pc-region-content {
    height: 400px;
    margin-top: 40px;
    display: flex;
    // bp数据
    .pc-region-content-data {
      width: 360px;
      height: 100%;
      box-shadow: $boxshadow;
      padding: 35px 30px;
      margin-right: 40px;
      > h2 {
        color: $mainTitle;
        font-size: 20px;
        padding-bottom: 15px;
        border-bottom: 2px solid $border-color;
      }
      ul {
        margin-top: 25px;

        li {
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;
          .title-label {
            display: flex;
            justify-content: center;

            h2 {
              width: 60px;
              align-self: center;
              font-size: 14px;
              text-align: center;
              color: $mainTitle;
              // margin-right: 20px;
            }
          }
          .title-label {
            display: flex;
            width: 100%;
            justify-content: center;
            span {
              align-self: center;
              font-size: 60px;
              margin-bottom: 5px;
              color: $visitorVolumeSmall;
            }
          }
        }
        li:nth-of-type(1) {
          span {
            color: $timeBtn;
          }
        }
        // li:nth-of-type(2), {
        //   span {

        //   }
        // }
      }
    }
    // 浏览趋势
    .pc-region-content-trend {
      width: 840px;
      box-shadow: $boxshadow;
      padding: 22px 30px;
      margin-right: 40px;

      // 浏览趋势头部功能样式
      .pc-region-content-trend-function {
        border-bottom: 2px solid $border-color;
        padding-bottom: 20px;
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        h2 {
          color: $mainTitle;
          font-size: 20px;
          align-self: center;
        }
        .trend-function {
          display: flex;
        }
      }
      // 浏览趋势底部echart图模块
      .pc-region-content-trend-echarts {
        padding-top: 30px;
      }
    }
    // 年度完成目标情况CSS
    .pc-region-content-finish {
      width: 360px;
      height: 100%;
      box-shadow: $boxshadow;
      padding: 35px 30px;
      margin-right: 40px;
      > h2 {
        font-size: 20px;
        color: $mainTitle;
        padding-bottom: 15px;
        border-bottom: 2px solid $border-color;
      }
      ul {
        display: flex;
        justify-content: space-between;
        li {
          span {
            font-size: 14px;
          }
          span:nth-of-type(2) {
            font-size: 20px;
          }
        }
        li:nth-of-type(1) {
          .finishNum {
            color: $visitorVolumeSmall;
          }
        }
        li:nth-of-type(2) {
          .finishNum {
            color: $timeBtn;
          }
          .el-icon-edit {
            color: $iconFinish;
          }
        }
      }
    }
  }

  // bp标签管理
  .pc-region-tab {
    // margin-right: 40px;
  }
  // bp表单
  .pc-region-table {
    // box-shadow: $boxshadow;
    // padding: 35px 30px;
    margin-top: 40px;
    // margin-right: 40px;
    > h2 {
      font-size: 20px;
      padding-bottom: 15px;
      color: $mainTitle;
      border-bottom: 2px solid $border-color;
    }
  }
  // 模块
  .search-templete {
    width: 100vw;
    height: 100vh;
    background: black;
    position: fixed;
    top: 0;
    opacity: 0;
  }
}


</style>



// WEBPACK FOOTER //
// src/components/admin/map/regionList.vue